import axios from 'axios';
import { API_URL } from './config/config';
import { jwt } from '../redux-modules/middleware/jwtMiddleware.js';

// function getApiUrl() {
//   if (window.location.hostname === "localhost") {
//     return 'https://virtserver.swaggerhub.com/Kindbody/Kindbody/1.0.0';
//   }
//   var r = {};
//   var regexParse = new RegExp('([a-z-0-9]{2,63}).([a-z.]{2,5})$');
//   var p = regexParse.exec(window.location.hostname);
//   r.domain = p[1];
//   r.type = p[2];
//   r.subdomain = window.location.hostname.replace(r.domain + '.' + r.type, '').slice(0, -1);
//   return `https://${r.subdomain}-api.${r.domain}.${r.type}/api/`;
// };

const apiRequest = async (url, params = {}) => {
  let config = {
    headers: {}
  };
  if (!url.includes('/login') && !url.includes('/refresh')) {
    config.headers = { 'Authorization': `Bearer ${await jwt()}` }
  } 

  try {
    const response = await axios({
      baseURL: API_URL,
      url: url,
      ...params,
      config
    });
    // throw new Error({});
    return response.data;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
      throw new Error('You are offline.  Please check your network and try again.')
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);

      const isError = error.response.status !== 200 && error.response.status !== 201 && error.response.status !== 204;
      const isJson = error.response.headers.get('content-type') && error.response.headers.get('content-type').includes('application/json');

      if (isError) {
        if (isJson) {
          const newError = await error.response.json();
          throw newError;
        }
        const newError = await error.response.text();
        throw newError;
      }
      else if (isJson) {
        try {
          const json = await error.response.json();
          return json;
        } catch (error) {
          return;
        }
      }
    }
    throw error;
  }
};

export const get = (url, options = {}) => {
  return apiRequest(url, {
    method: 'get',
    ...options
  })
};

export const post = (url, data, options = {}) => {
  return apiRequest(url, {
    method: 'post',
    data: data,
    ...options
  })
};

export const put = (url, data, options = {}) => {
  return apiRequest(url, {
    method: 'put',
    data: data,
    ...options
  })
};

export default apiRequest;



// WEBPACK FOOTER //
// ./src/api/apiUtils.js